import { render, staticRenderFns } from "./detailsPrint.vue?vue&type=template&id=712c917c&scoped=true"
import script from "./detailsPrint.vue?vue&type=script&lang=js"
export * from "./detailsPrint.vue?vue&type=script&lang=js"
import style0 from "./detailsPrint.vue?vue&type=style&index=0&id=712c917c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712c917c",
  null
  
)

export default component.exports